import React, { useState, useEffect, Fragment } from 'react';
import { Combobox, Transition } from '@headlessui/react'



/*
getData = (query) => Promise<[]>;
getDisplay = (resource) => str | null;
getId = (resource) => any;
currentValue: any | null;

*/

function ComboboxAutocompleteAPI({ getData, getDisplay, getId, currentValue, onChange, placeholder = 'Digita per cercare...' }) {
  const [selectedValue, setSelectedValue] = useState(currentValue);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState('');
  const bgActiveColor = 'bg-indigo-100';
  const textActiveColor = 'text-gray-700';

  useEffect(() => {
    async function retriveData() {
      const results = await getData(query);
      if (results) setOptions(results);
    }

    if (query !== '') {
      retriveData();
    } else {
      setOptions([]);
    }
  }, [query, getData]);

  const handleSelect = (value) => {
    if (!value) {
      onChange(null);
      setSelectedValue(null);
    } else {
      onChange(value);
      setSelectedValue(value);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setQuery(value);

    if (value === '') {
      handleSelect(null); 
    }
  };

  return (
    <Combobox value={selectedValue} onChange={handleSelect}>
      <div className="relative mt-1">
        <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
          <Combobox.Input 
            className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
            displayValue={(element) => (element && currentValue) ? getDisplay(element) : ''}
            onChange={handleInputChange}
            placeholder={placeholder}
          />
        </div>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery('')}
        >
            <Combobox.Options className={`absolute mt-1 max-h-60 w-full z-40 overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`}>
            {options.map((resource) => (
              <Combobox.Option
                key={getId(resource)}
                value={resource}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pl-10 pr-4 ${
                    active ? `${bgActiveColor} ${textActiveColor}` : 'text-gray-900'
                  }`
                }
              >
                {getDisplay(resource)}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}

export default ComboboxAutocompleteAPI;